import { useEffect, useState } from 'react';

export const useFilteredTickets = (
  tickets: any,
  filterOption: Object,
  searchText: string,
) => {
  const [filteredTickets, setFilteredTickets] = useState([]);

  useEffect(() => {
    // Start with tickets.data which is the array
    let localTickets = { ...tickets };

    if (filterOption.lob === 'All' && tickets?.data?.length > 0)
      localTickets = { ...tickets };
    else {
      localTickets = {
        ...localTickets,
        data: localTickets.data?.filter(
          (ticket: any) => ticket.ticket.tower === filterOption.lob,
        ),
      };
    }

    if (filterOption.owner === 'All') localTickets = { ...localTickets };
    else
      localTickets = {
        ...localTickets,
        data: localTickets.data?.filter(
          (ticket: any) => ticket.ticket.assigned_to === filterOption.owner,
        ),
      };

    if (filterOption.region === 'All regions')
      localTickets = { ...localTickets };
    else {
      localTickets = {
        ...localTickets,
        data: localTickets.data?.filter(
          (ticket: any) => ticket.ticket.region === filterOption.region,
        ),
      };
    }

    if (searchText) {
      localTickets = {
        ...localTickets,
        data: localTickets.data?.filter((ticket: any) => {
          const ticketValues = Object.values(ticket.ticket || {});
          return ticketValues.some(
            value =>
              value &&
              value.toString().toLowerCase().includes(searchText.toLowerCase()),
          );
        }),
      };
    }
    setFilteredTickets(localTickets);
  }, [tickets, filterOption, searchText]);

  return { filteredTickets };
};
